import { LocalDB } from "./Utils";

export class LevelManager {
    private static instance: LevelManager;
    private localDB: LocalDB;

    private constructor() {
        this.localDB = new LocalDB('CricketMania');
        //console.log(this.localDB.getItem<number[]>('completedLevels'));
    }

    public static getInstance(): LevelManager {
        if (!LevelManager.instance) {
            LevelManager.instance = new LevelManager();
        }
        return LevelManager.instance;
    }

    public setLevelCompleted(levelNumber: number): void {
        let completedLevels = this.getCompletedLevels();
        if (!completedLevels.includes(levelNumber)) {
            completedLevels.push(levelNumber);
            this.localDB.setItem('completedLevels', completedLevels);
        }
    }

    public isLevelCompleted(levelNumber: number): boolean {
        let completedLevels = this.getCompletedLevels();
        return completedLevels.includes(levelNumber);
    }

    public getCompletedLevels(): number[] {
        return this.localDB.getItem<number[]>('completedLevels') || [];
    }

    public resetProgress(): void {
        this.localDB.setItem('completedLevels', []);
    }

    public getHighestCompletedLevel(): number {
        if(typeof window.levels != 'undefined'){
            return window.levels;
        }
        let completedLevels = this.getCompletedLevels();
        return completedLevels.length > 0 ? Math.max(...completedLevels) : 0;
        // return 50;
    }

    // public static cheatCommandToUnlockAll(): void {
    //     let levelManager = LevelManager.getInstance();
    //     window.levels = 50;
    //     levelManager.setLevelCompleted(50);
    // }
    // public static cheatCommandToLockAll(): void{
    //     let levelManager = LevelManager.getInstance();
    //     window.levels = 1;
    //     levelManager.setLevelCompleted(2);
    // }
}